import styles from "./incomplete_step_warning.module.scss"

interface Warning {
  type: "connection" | "configuration" | "dependency"
  message: string
  action: () => void
}

interface Props {
  warnings: Warning[]
}

export default function IncompleteStepWarning({ warnings }: Props) {
  if (!warnings.length) return null

  return (
    <div className={styles["warning-container"]}>
      {warnings.map((warning, index) => (
        <div key={index} className={styles["warning"]}>
          <div className={styles["warning-icon"]}>
            <svg viewBox="0 0 24 24" className={styles["warning-svg"]} fill="none">
              <path
                clipRule="evenodd"
                d="M11.9748 23.9496C5.3612 23.9496 0 18.5884 0 11.9748C0 5.3612 5.3612 0 11.9748 0C18.5884 0 23.9496 5.3612 23.9496 11.9748C23.9496 18.5884 18.5884 23.9496 11.9748 23.9496ZM13.948 16.9436C13.948 16.7068 13.9016 16.4792 13.8096 16.2612C13.7212 16.049 13.589 15.8579 13.4216 15.7004C13.2515 15.542 13.0544 15.4153 12.8396 15.3264C12.6174 15.2329 12.3786 15.1852 12.1376 15.1864C11.8966 15.1853 11.6578 15.2329 11.4356 15.3264C11.2212 15.415 11.0265 15.5452 10.8628 15.7096C10.7028 15.872 10.5764 16.0616 10.484 16.28C10.3921 16.4956 10.3448 16.7276 10.3452 16.962C10.3429 17.2008 10.3935 17.4371 10.4932 17.654C10.5892 17.862 10.7204 18.0516 10.8812 18.2148C11.0412 18.3768 11.2332 18.5044 11.4448 18.5888C11.6651 18.6769 11.9004 18.7213 12.1376 18.7196C12.3836 18.7196 12.618 18.6728 12.8396 18.5796C13.0543 18.4905 13.2514 18.3639 13.4216 18.2056C13.5892 18.048 13.7216 17.8572 13.8096 17.6448C13.9027 17.4228 13.9497 17.1843 13.948 16.9436V16.9436ZM10.5856 14.102V14.1016H13.6896V5.296H10.5856V14.102Z"
                fill="#333333"
                fillRule="evenodd"
              />
            </svg>
          </div>
          <div className={styles["warning-text"]}>{warning.message}</div>
        </div>
      ))}
    </div>
  )
}

// Helper function to get warnings for a step
export const getStepWarnings = (step: any, stepType: string, dispatch: (action: any) => void): Warning[] => {
  if (!step?.isFromTemplate) return []

  const warnings: Warning[] = []

  // Check for trigger dependency (highest priority)
  if (step.disabled && step.isFromTemplate && stepType !== 'trigger') {
    warnings.push({
      type: "dependency",
      message: `Please add a trigger to finish setting up this ${stepType}.`,
      action: () => dispatch({ type: "SELECTING_TRIGGER_SERVICE" }),
    })
    return warnings
  }

  // Check for service connection
  if (step.needsConnection) {
    warnings.push({
      type: "connection",
      message: `There is no account attached here. Please edit this ${stepType}.`,
      action: () => dispatch({
        type: `CONNECTING_${stepType.toUpperCase()}_SERVICE`,
        value: step,
      })
    })
  }

  // Check for field configuration
  if (step.needsConfiguration && step.live_channel_id) {
    warnings.push({
      type: "configuration",
      message: `Missing fields. Please finish configuring this ${stepType} by going to edit.`,
      action: () => dispatch({
        type: `SELECTING_${stepType.toUpperCase()}_FIELDS`,
        value: step,
      })
    })
  }

  return warnings
}
